import React, { useState } from 'react';

const LabeledValue = ({ label, value, unit }) => (
  <h3 style={{ textAlign: 'left', width: '50%', marginTop: '20px' }}>
    {label}
    <span style={{ marginLeft: '10px', fontWeight: 'bold' }}>
      {value} {unit}
    </span>
  </h3>
);

const DipstickCalibration = (props) => {
  if (!props.asset) return null;

  const { asset, setAssetView, strings } = props;
  const [dipstick, setDipstick] = useState(parseFloat(asset.dipstick) || 0);

  const deviceKey = Object.keys(asset.SensorStatus.devices)[0];
  const tankHeight = asset.assetType.waterTank_config.theigth || 0;
  const deviceDistance = (asset.SensorStatus.devices[deviceKey].sensorLastReadingValue || 0) / 10;
  const deviceLecture = tankHeight - deviceDistance;
  const adjustment = deviceLecture - dipstick;
  const sensorDepthOffset = asset.sensors.sensors[0].depthOffset || 0;
  const suggestedOffset = adjustment * 10;

  return (
    <div>
      <div className="row">
        <section className="col-lg-12 connectedSortable ui-sortable">
          <div className="box box-info" style={{ padding: '20px' }}>
            <div className="box-header ui-sortable-handle" style={{ cursor: 'move' }}>
              <i className="fa fa-area-chart" />
              <h3 className="box-title">
                {strings.dipstick_device_offset}
              </h3>
              <div className="pull-right box-tools"></div>
            </div>
            <div className="box-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <LabeledValue label={strings.tank_height_config} value={tankHeight} unit="cm" />
              <div style={{ display: 'flex', alignItems: 'center', width: '50%', marginTop: '10px' }}>
                <h3 style={{ marginRight: '10px', textAlign: 'left' }}>
                  {strings.enter_dipstick_measurement}
                </h3>
                <input
                  type="number"
                  className="form-control"
                  placeholder={strings.centimeters}
                  name="dipstick"
                  onChange={(evt) => setDipstick(parseFloat(evt.target.value) || 0)}
                  style={{ maxWidth: '120px', marginLeft: '20px' }}
                />
              </div>
              <LabeledValue label={strings.last_device_distance} value={deviceDistance} unit="cm" />
              <div style={{ textAlign: 'left', width: '50%', marginTop: '10px' }}>
                <LabeledValue label={strings.dipstick_lecture} value={dipstick} unit="cm" />
                <LabeledValue label={strings.device_lecture} value={deviceLecture} unit="cm" />
                <LabeledValue label={strings.adjustment} value={adjustment} unit="cm" />
                <LabeledValue label={strings.the_actual_offset_is} value={sensorDepthOffset} unit="mm" />
                <LabeledValue label={strings.the_suggested_offset_is} value={suggestedOffset} unit="mm" />
              </div>
              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                <button type="button" className="btn btn-block btn-primary" style={{ width: '100px' }} onClick={() => setAssetView("details")}>
                  {strings.close}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default DipstickCalibration
